export default "__VITE_ASSET__0b6e7c18__"